import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const Root = styled("div")(({ theme }) => ({
  width: "100%",
  position: "relative",
  background: theme.palette.primary.gradient,
  height: 195,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.up("mobile")]: {
    height: 370,
  },
  [theme.breakpoints.up("tablet")]: {
    height: 643,
  },
}));

export const Video = styled("video")({
  position: "absolute",
  width: "100%",
  height: "100%",
  opacity: 0.5,
  objectFit: "cover",
});

export const Content = styled("div")({
  position: "relative",
  textAlign: "center",
});

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const Logo = styled("img")(({ theme }) => ({
  width: 112,
  [theme.breakpoints.up("mobile")]: {
    width: 208,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 371,
  },
}));
